module.exports = __webpack_public_path__ + "static/media/emily.036cc230.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/emily.jpeg
// module id = 277
// module chunks = 0